(function () {
  document.querySelectorAll('[data-google-form-id]').forEach(function (form) {
    var formId = form.dataset.googleFormId;
    if (!formId) return;

    var endpoint = 'https://docs.google.com/forms/d/e/' + formId + '/formResponse';
    var messageEl = form.querySelector('[data-form-message]');
    var submitBtn = form.querySelector('[type="submit"]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      submitBtn.setAttribute('disabled', '');
      submitBtn.classList.add('button--loading');
      messageEl.classList.add('hidden');

      var formData = new FormData(form);

      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        body: formData
      })
        .then(function () {
          messageEl.textContent = form.dataset.successMessage;
          messageEl.classList.remove('hidden');
          messageEl.classList.add('form-returns__message--success');
          messageEl.classList.remove('form-returns__message--error');
          form.reset();
        })
        .catch(function () {
          messageEl.textContent = form.dataset.errorMessage;
          messageEl.classList.remove('hidden');
          messageEl.classList.add('form-returns__message--error');
          messageEl.classList.remove('form-returns__message--success');
        })
        .finally(function () {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.remove('button--loading');
          messageEl.focus();
        });
    }, { capture: true });
  });
})();
